export default "__VITE_ASSET__BnlUB75O__"